<template>
    <div>
        <tile-question-layout v-show="panel_required"
                :options_loaded="options_loaded"
                :passed_filter="passed_filter"
                :title="title"
                :loading="loading"
                v-model:target="localTarget"
                :filtered_option_list="filtered_option_list"
                :thumb_url="thumbURL"
                :component_id="component_id"
                :fabricator="fabricator"
        ></tile-question-layout>
    </div>
</template>
